"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGTMEvent = void 0;
exports.GoogleTagManager = GoogleTagManager;
const jsx_runtime_1 = require("react/jsx-runtime");
// TODO: Evaluate import 'client only'
const script_1 = __importDefault(require("next/script"));
const react_1 = __importStar(require("react"));
const safevalues_1 = require("safevalues");
let currDataLayerName;
/**
 * A Google Tag Manager component that initializes the GTM script.
 * This component must be placed as a direct child of the <body>
 *
 * To blocklist certain categories of tags use the information at:
 * https://developers.google.com/tag-platform/tag-manager/restrict
 * @param props See GTMParams type for more information.
 * @returns A GoogleTagManager component.
 */
function GoogleTagManager(props) {
    const { gfiberGtmId, gtmId, dataLayerName = 'dataLayer', auth, preview, dataLayer, nonce, } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    const gtmLayer = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
    const gtsentryth = auth ? `&gtm_auth=${auth}` : '';
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';
    const gfiberGtmIframeUrl = `https://www.googletagmanager.com/ns.html?id=${gfiberGtmId || ''}`;
    const gtmIframeUrl = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    const gfiberGtmScriptUrl = (0, safevalues_1.trustedResourceUrl) `https://www.googletagmanager.com/gtm.js?id=${gfiberGtmId || ''}${gtmLayer}${gtsentryth}${gtmPreview}`;
    const gtmScriptUrl = (0, safevalues_1.trustedResourceUrl) `https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtsentryth}${gtmPreview}`;
    const gtmInitScript = (0, safevalues_1.safeScriptWithArgs) `function(l,dl){
  window[l]=window[l]||[];
  window[l].push(dl);
  window[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
  }`(dataLayerName, dataLayer || {});
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-gtm',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm-init", nonce: nonce, children: gtmInitScript }), (0, jsx_runtime_1.jsxs)("noscript", { children: [(0, jsx_runtime_1.jsx)("iframe", { id: "next-gtm-noscript", src: gtmIframeUrl, height: "0", title: "GTM for Google Fiber", width: "0", style: { display: 'none', visibility: 'hidden' } }), gfiberGtmId && ((0, jsx_runtime_1.jsx)("iframe", { id: "next-gfiber-gtm-noscript", src: gfiberGtmIframeUrl, height: "0", title: "GTM for GFiber", width: "0", style: { display: 'none', visibility: 'hidden' } }))] }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm", "data-ntpc": "GTM", src: gtmScriptUrl, strategy: "lazyOnload", nonce: nonce }), gfiberGtmId && ((0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gfiber-gtm", "data-ntpc": "GFIBER-GTM", src: gfiberGtmScriptUrl, strategy: "lazyOnload", nonce: nonce }))] }));
}
const sendGTMEvent = (data) => {
    if (currDataLayerName === undefined) {
        console.warn('@gfiber/third-parties: GTM has not been initialized');
        return;
    }
    const dataLayer = Reflect.get(window, currDataLayerName);
    if (Array.isArray(dataLayer)) {
        dataLayer.push(data);
    }
    else {
        console.warn(`@gfiber/third-parties: GTM dataLayer ${currDataLayerName} does not exist`);
    }
};
exports.sendGTMEvent = sendGTMEvent;
